module.exports = __webpack_public_path__ + "public/static/Noresultfound.svg?da46991d";